import { render, staticRenderFns } from "./ResalePropertDetailsList.vue?vue&type=template&id=5b5023d3&"
import script from "./ResalePropertDetailsList.vue?vue&type=script&lang=js&"
export * from "./ResalePropertDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports